export enum ECaseBusinessClassification {
  SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
  PARTNERSHIP = 'PARTNERSHIP',
  LIMITED_PARTNERSHIP = 'LIMITED_PARTNERSHIP',
  LIMITED_LIABILITY_PARTNERSHIP = 'LIMITED_LIABILITY_PARTNERSHIP',
  EXEMPT_PRIVATE_COMPANY = 'EXEMPT_PRIVATE_COMPANY',
  A1 = 'A1',
  A3 = 'A3',
  A4 = 'A4',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  B4 = 'B4',
  F1 = 'F1',
}

export type CASE_BUSINESS_CLASSIFICATION = keyof typeof ECaseBusinessClassification;

export enum ECaseBusinessActivity {
  BUILDING_AND_CONSTRUCTION = 'BUILDING_AND_CONSTRUCTION',
  FOOD_AND_BEVERAGE = 'FOOD_AND_BEVERAGE',
  GENERAL_COMMERCE = 'GENERAL_COMMERCE',
  MANUFACTURING = 'MANUFACTURING',
  RETAIL = 'RETAIL',
  TRANSPORTATION_STORAGE = 'TRANSPORTATION_STORAGE',
  ELECTRONICS = 'ELECTRONICS',
  HOSPOTALITY = 'HOSPOTALITY',
  LOGISTICS_WAREHOUSING = 'LOGISTICS_WAREHOUSING',
  PROFESSIONAL_PRACTICES = 'PROFESSIONAL_PRACTICES',
  SERVICES = 'SERVICES',
  OTHER = 'OTHER',
}

export type CASE_BUSINESS_ACTIVITY = keyof typeof ECaseBusinessActivity;

export enum ECaseBusinessPremiseOwnership {
  FREE_FROM_ENCUMBRANCES = 'FREE_FROM_ENCUMBRANCES',
  OWNED_BY_RELATED_PARTY = 'OWNED_BY_RELATED_PARTY',
  MORTGAGED = 'MORTGAGED',
  RENTED = 'RENTED',
}

export type CASE_BUSINESS_PREMISE_OWNERSHIP = keyof typeof ECaseBusinessPremiseOwnership;

export enum ECaseBusinessNTBETB {
  NEW_TO_BANK = 'NEW_TO_BANK',
  EXISTING_TO_BANK = 'EXISTING_TO_BANK',
}

export type CASE_BUSINESS_NTB_ETB = keyof typeof ECaseBusinessNTBETB;

export enum ECaseBusinessAddressType {
  RESIDENTIAL_ADDRESS = 'RESIDENTIAL_ADDRESS',
  MAILING_ADDRESS = 'MAILING_ADDRESS',
}

export type CASE_BUSINESS_ADDRESS_TYPE = keyof typeof ECaseBusinessAddressType;

export enum ECaseBusinessCompanyType {
  PUBLIC_COMPANY_LIMITED_BY_SHARES = 'PUBLIC_COMPANY_LIMITED_BY_SHARES',
  PUBLIC_COMPANY_LIMITED_BY_GUARANTEE = 'PUBLIC_COMPANY_LIMITED_BY_GUARANTEE',
  UNLIMITED_PUBLIC_COMPANY = 'UNLIMITED_PUBLIC_COMPANY',
  PRIVATE_COMPANY_LIMITED_BY_SHARES = 'PRIVATE_COMPANY_LIMITED_BY_SHARES',
  EXEMPT_PRIVATE_COMPANY_LIMITED_BY_SHARES = 'EXEMPT_PRIVATE_COMPANY_LIMITED_BY_SHARES',
  UNLIMITED_PRIVATE_COMPANY = 'UNLIMITED_PRIVATE_COMPANY',
  UNLIMITED_EXEMPT_PRIVATE_COMPANY = 'UNLIMITED_EXEMPT_PRIVATE_COMPANY',
  FOREIGN_COMPANY_REGISTERED_IN_SINGAPORE = 'FOREIGN_COMPANY_REGISTERED_IN_SINGAPORE',
}

export type CASE_BUSINESS_COMPANY_TYPE = keyof typeof ECaseBusinessCompanyType;
